// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"91623c87","796":"1f446da1"}[chunkId] + ".chunk.js";
};